import Api from '../base/index.js'

export default{
    async uploadImage(data){
        return Api.post(`tiny_mce_img_upload`, data)
    },
}